import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { EERIE } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Header = styled.div.withConfig({
  displayName: "FloatingRemoveButton__Header",
  componentId: "sc-1jiiti9-0"
})(["position:absolute;top:10px;right:-22px;z-index:10;"]);
const HoverContainer = styled.div.withConfig({
  displayName: "FloatingRemoveButton__HoverContainer",
  componentId: "sc-1jiiti9-1"
})(["position:relative;"]);
const FloatingHeader = ({
  onClick,
  title,
  tooltipPlacement = 'top left'
}) => /*#__PURE__*/_jsx(Header, {
  children: /*#__PURE__*/_jsx(UITooltip, {
    title: title,
    placement: tooltipPlacement,
    children: /*#__PURE__*/_jsx(UIIconButton, {
      size: "xs",
      use: "tertiary-light",
      onClick: onClick,
      "data-test-id": "floating-remove-button",
      children: /*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-0",
        color: EERIE,
        name: "remove",
        size: 12
      })
    })
  })
});
FloatingHeader.displayName = 'FloatingHeader';

/**
 * This component can be wrapped around a component to provide a hovering remove
 * button
 */
const FloatingRemoveButton = ({
  children,
  onClick,
  title,
  tooltipPlacement
}) => {
  const [isHovered, setIsHovering] = useState(false);
  const onMouseEnter = useCallback(() => setIsHovering(true), []);
  const onMouseLeave = useCallback(() => setIsHovering(false), []);
  return /*#__PURE__*/_jsxs(HoverContainer, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    "data-test-id": "floating-remove-button-container",
    children: [isHovered && /*#__PURE__*/_jsx(FloatingHeader, {
      onClick: onClick,
      title: title,
      tooltipPlacement: tooltipPlacement
    }), children]
  });
};
FloatingRemoveButton.displayName = 'FloatingRemoveButton';
export { FloatingRemoveButton as default, FloatingHeader as __FloatingHeader };